import { render, staticRenderFns } from "./download.vue?vue&type=template&id=a7955bd6&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"
import style0 from "./download.vue?vue&type=style&index=0&id=a7955bd6&prod&scoped=true&lang=less"
import style1 from "./download.vue?vue&type=style&index=1&id=a7955bd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7955bd6",
  null
  
)

export default component.exports